import { OrientacionI } from "interfaces/Orientacion";

export interface infoFecthOrientacionI {
  id: number | string;
  nombre: string;
}

class Orientacion implements OrientacionI {
  id: number | string;
  nombre: string;

  constructor(infoFetch: infoFecthOrientacionI) {
    this.id = infoFetch.id;
    this.nombre = infoFetch.nombre;
  }
}

export const makeOrientacion = (infoFetch: infoFecthOrientacionI) => {
  return new Orientacion(infoFetch);
};
